/*
 * サブシステム名：設定その他
 * 機能名：ETC利用料金サイトデータ取込
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import VTour from '@/components/DdCoachMark.vue'
import CoachMark from './CoachMark/D2PRMT0810.js'

import DdCheckbox from '@/components/DdCheckbox'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdFileInput from '@/components/DdFileInput'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdSelectItemsPerPage from '@/components/DdSelectItemsPerPage'
import DdSubHeader from '@/components/DdSubHeader'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
import modals from '@/ddv2.library/modals'
import validators from '@/rahmen/validators'

export default {
  name: 'EtcDataImport',
  mixins: [flowMixin],
  components: {
    VTour,
    DdCustomButton,
    DdTransparentButton,
    DdCheckbox,
    DdCodeTextBox,
    DdDateRangeBox,
    DdFileInput,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdSelectItemsPerPage,
    DdSubHeader
  },
  data: () => ({
    isSelect: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,
    conditions: {
      kaishaCd: '0010',
      riyoKikanYmdFrom: '',
      riyoKikanYmdTo: '',
      eigyoshoId: '',
      sharyoId: '',
      onlySharyoOnMaster: false
    },
    modeKengen: 0,
    // 操作ガイド用
    startCoachMark: false,
    steps: CoachMark.STEPS,
    // オートコンプリート用ヘッダー
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    rows: []
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      eigyoshoList: 'DDMasters/mstEigyosho',
      sharyoList: 'DDMasters/vwCMstSharyo',
      systemConfigList: 'DDMasters/msysSystemConfig',
      currentKaishaCode: 'users/currentKaishaCode',
      helpUseFlg: 'users/helpUseFlg'
    }),
    // 営業所マスタフィルター --> ここから
    filteredMstEigyosho () {
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    filteredMstEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstEigyosho.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 車両マスタフィルター --> ここから
    filteredMstSharyo () {
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    // ※傭車は除く
    filteredMstSharyoList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstSharyo.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === false
      })
    },
    // 車両マスタフィルター <-- ここまで
    isValidImportButton () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    },
    filteredRows () {
      return this.rows.map((elem) => {
        return elem
      })
    },
    serviceSiteUrl () {
      const r = indexeddb.getSystemConfig(this.currentKaishaCode, this.systemConfigList, 'web_url_etc_base_display')
      if (r) {
        return r.configValue1
      }
      return 'https://www.etc-meisai.jp/index.html'
    },
    // CSVボタン活性条件
    isCsvButtonDisabled () {
      return this.rows.length === 0 || this.isCsvDownloader
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmstsharyo', 'msyssystemconfig'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.headers = [
              { text: 'No', value: 'no', align: 'center' },
              { text: '状態', value: 'status', align: 'center' },
              { text: '車両番号', value: 'etcSharyoNo' },
              { text: '利用日時（自）', value: 'riyoJiYmdHms' },
              { text: '利用IC（自）', value: 'riyoJiIc' },
              { text: '利用日時（至）', value: 'riyoItaYmdHms' },
              { text: '利用IC（至）', value: 'riyoItaIc' },
              { text: '割引前料金', value: 'etcWaribikiMaeRyokinDisp', align: 'right' },
              { text: 'ETC割引額', value: 'etcWaribikiKingakuDisp', align: 'right' },
              { text: '通行料金', value: 'etcTsukoRyokinDisp', align: 'right' },
              { text: '還元額適用料金', value: 'etcKangenTekiyoRyokinDisp', align: 'right' },
              { text: '前払金適用料金', value: 'etcMaebaraiTekiyoRyokinDisp', align: 'right' },
              { text: '後納料金', value: 'etcGonoRyokinDisp', align: 'right' },
              { text: '車種', value: 'etcShashuSbt' },
              { text: 'ETC番号', value: 'etcNo' },
              { text: '備考', value: 'etcBiko' },
              { text: '営業所', value: 'eigyoshoNm' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              kaishaCd: this.currentKaishaCode,
              riyoStartYmd: dayjs().add(-1, 'month').format('YYYY/MM/DD'),
              riyoEndYmd: dayjs().add(-1, 'd').format('YYYY/MM/DD'),
              eigyoshoId: '',
              sharyoId: '',
              onlySharyoOnMaster: false
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    clear: function () {
      console.log('clear pushed')
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              kaishaCd: this.currentKaishaCode,
              riyoStartYmd: dayjs().add(-1, 'month').format('YYYY/MM/DD'),
              riyoEndYmd: dayjs().add(-1, 'd').format('YYYY/MM/DD'),
              eigyoshoId: '',
              sharyoId: ''
            }
            this.searchText = ''
            this.rows = []
            this.isSelect = []
            this.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onSearchButtonClick: function (e) {
      this.isSelect = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.conditions.kaishaCd = this.currentKaishaCode
            self.HttpClient.post('/api/v1/D2PRMD0810/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          console.log('retdata', data)
          // this.transition(0, { id: data.payload, edit: 1 })
          var i = 1
          self.rows = data.payload.map((e) => {
            const jh = dayjs('2000/01/01 ' + e.riyoJiHms)
            e.riyoJiYmdHms = dayjs(e.riyoJiYmd).add(jh.hour(), 'h').add(jh.minute(), 'm').format('YYYY/MM/DD HH:mm')
            const ji = dayjs('2000/01/01 ' + e.riyoItaHms)
            e.riyoItaYmdHms = dayjs(e.riyoItaYmd).add(ji.hour(), 'h').add(ji.minute(), 'm').format('YYYY/MM/DD HH:mm')

            e.etcWaribikiMaeRyokinDisp = e.etcWaribikiMaeRyokin ? filter.numericFormatter(e.etcWaribikiMaeRyokin ?? 0) : ''
            e.etcWaribikiKingakuDisp = e.etcWaribikiKingaku ? filter.numericFormatter(e.etcWaribikiKingaku ?? 0) : ''
            e.etcTsukoRyokinDisp = e.etcTsukoRyokin ? filter.numericFormatter(e.etcTsukoRyokin ?? 0) : ''
            e.etcKangenTekiyoRyokinDisp = e.etcKangenTekiyoRyokin ? filter.numericFormatter(e.etcKangenTekiyoRyokin ?? 0) : ''
            e.etcMaebaraiTekiyoRyokinDisp = e.etcMaebaraiTekiyoRyokin ? filter.numericFormatter(e.etcMaebaraiTekiyoRyokin ?? 0) : ''
            e.etcGonoRyokinDisp = e.etcGonoRyokin ? filter.numericFormatter(e.etcGonoRyokin ?? 0) : ''
            e.no = i
            i++
            e.status = (e.trUnkoJissekiId && e.trUnkoJissekiId !== 0) ? '済' : ''
            return e
          })

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
          }
        }
      }
      this.search(opt)
    },
    onTorikomiButtonClick: function (e) {
      const self = this
      this.clearSummaryMessage()
      console.log('cklick')
      if (this.validateAll(this.$refs)) {
        this.Effects.loadStart()
        console.log('serach start', e, this.conditions)
        this.conditions.kaishaCd = this.currentKaishaCode
        this.HttpClient.post('/api/v1/D2PRMD0810/GetFromSite', this.conditions)
          .then((data) => {
            if (data.isValid) {
              console.log('retdata', data)
              self.onSearchButtonClick()
              this.Effects.loadComplete()
            } else {
              this.setSummaryMessage(data.summaryMessage)
              this.Effects.loadComplete()
            }
          }).catch((e) => {
            console.log('error', e)
            this.setSummaryMessage({ messageCd: '', message: e.message })
            this.Effects.loadComplete()
          })
      }
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onDeleteButtonClick: function (e) {
      // const self = this
      this.clearSummaryMessage()
      const p = modals.showConfirm
      p('COMQ0003').then((ok) => {
        if (ok === false || ok === undefined) { return }

        this.Effects.loadStart()

        this.HttpClient.post('/api/v1/D2PRMD0810/MultiDelete', this.isSelect)
          .then((data) => {
            if (data.isValid) {
              this.isSelect = []
              this.page = 1
              console.log('retdata', data)
              this.onSearchButtonClick()
              this.Effects.loadComplete()
            } else {
              this.setSummaryMessage(data.summaryMessage)
              this.Effects.loadComplete()
            }
          }).catch((e) => {
            console.log('error', e)
            this.setSummaryMessage(e.message)
            this.Effects.loadComplete()
          })
      })
    },
    onCancelButtonClick: function (e) {

    },
    onCsvButtonClick: function (e) {
      this.isCsvDownloader = true
      this.HttpClient
        .post('/api/v1/D2PRMD0810/download', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('csvdownload')
          this.isCsvDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = 'ETCデータ一覧_' + dayjs().format('YYYYMMDD_HHmmss') + '.csv'
          elem.click()
        })
    },
    onPdfButtonClick: function (e) {

    },
    searchValidate: function () {
      var ret = true
      const msg = validators.compareDate(this.conditions.riyoStartYmd, this.conditions.riyoEndYmd)
      if (msg !== undefined) {
        this.$refs.riyoStartYmd[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.riyoEndYmd[this.Ctrls.SET_INVALID_METHOD](msg)
        ret = false
      }
      return ret
    },
    getSharyoNoFromId (pid) {
      const r = indexeddb.getRecord(this.sharyoList, pid)
      if (r) {
        return r.torokuIchirenShiteiNo
      }
      return null
    },
    getEigyoshoNmFromId (pid) {
      const r = indexeddb.getRecord(this.eigyoshoList, pid)
      if (r) {
        return r.torokuIchirenShiteiNo
      }
      return null
    },
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      // this.$set(this, 'itemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    // ダミー
    onDummyFunction: function () {
      this.$emit('dummy')
    }
  }
}
